import moment from 'moment';
import i18n from 'i18next';

//──── Week day ──────────────────────────────────────────────────────────────────────────
export const daysOfWeek = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

export const selectedDaysList = [
  { id: 'Monday', title: 'weekdays_filter_popup_1' },
  { id: 'Tuesday', title: 'weekdays_filter_popup_2' },
  { id: 'Wednesday', title: 'weekdays_filter_popup_3' },
  { id: 'Thursday', title: 'weekdays_filter_popup_4' },
  { id: 'Friday', title: 'weekdays_filter_popup_5' },
  { id: 'Saturday', title: 'weekdays_filter_popup_6' },
  { id: 'Sunday', title: 'weekdays_filter_popup_7' },
];

export const getWeekDayString = (daysList) => {
  let arr = [];
  if (Array.isArray(daysList)) {
    selectedDaysList.forEach((d) => {
      if (daysList.includes(d.id)) { arr.push(i18n.t(d.title)); }
    });
  }
  return arr.join(', ');
};

export const parseWeekDayToString = (daysList) => {
  if (Array.isArray(daysList)) {
    if (daysList.length === daysOfWeek.length) {
      return i18n.t('all_day');
    } else {
      let arr = [];
      selectedDaysList.forEach((d) => {
        if (daysList.includes(d.id)) { arr.push(i18n.t(d.title)); }
      });
      return arr.join(', ');
    }
  } else {
    return i18n.t('no_data');
  }

};

//──── Day period ────────────────────────────────────────────────────────────────────────
export const dayTimePeriodsList = [
  {
    id: 'AllDay',
    title: i18n.t('all_day'),
    value: ['morning', 'afternoon', 'evening'],
    startTime: '05:00:00',
    endTime: '23:00:00',
  },
  {
    id: 'morning',
    title: i18n.t('morning'),
    value: ['morning'],
    startTime: '05:00:00',
    endTime: '12:00:00',
  },
  {
    id: 'afternoon',
    title: i18n.t('afternoon'),
    value: ['afternoon'],
    startTime: '12:00:00',
    endTime: '17:00:00',
  },
  {
    id: 'evening',
    title: i18n.t('evening'),
    value: ['evening'],
    startTime: '17:00:00',
    endTime: '23:00:00',
  },
];

export const getDayTimePeriodString = (partsList) => {
  if (Array.isArray(partsList)) {
    const partDayItem = dayTimePeriodsList.find(part => part.value.toString() === partsList.toString());
    return partDayItem ? partDayItem.title : i18n.t('no_data');
  }
};


export const dateWithTimezone = (date, format = 'HH:mm') => {
  const currentDate = moment(date);
  if (currentDate.isValid) {
    return moment
      .utc(date)
      .local()
      .format(format);
  }
  return date;
};

export const isToday = date =>
  moment(date).isValid() ? moment(date).isSame(moment(), 'day') : date;

export const startDayWithUtc = date =>
  moment(date).isValid() &&
  moment(date)
    .startOf('day')
    .add(moment(date).utcOffset(), 'minutes')
    .utc()
    .format();

export const dateForRequest = momentDate =>
  moment(momentDate).isValid() && moment(momentDate).format('YYYY-MM-DDTHH:mm:ss');

export const sortAppointmentsForDateTime = appointments =>
  appointments.sort((a, b) => {
    if (moment(a.dateTime).isSame(moment(b.dateTime)) && a.id && b.id) {
      return a.id - b.id;
    }
    return moment(a.dateTime).isBefore(moment(b.dateTime)) ? -1 : 1;
  });

export const sectionListTitle = time => {
  if (moment(time).isValid()) {
    return moment(time).format(i18n.language === 'nl' ? 'dddd DD MMMM' : 'dddd, MMMM DD');
  }
  return time;
};

